module.exports = __webpack_public_path__ + "img/carrygo-bikes.5e418f7f.jpg";